import clsx from 'clsx'
import type { ComponentProps } from 'react'

type Props = ComponentProps<'input'> & {
  label: string
}
export const AdminRadio = ({ label, ...props }: Props) => (
  <div>
    <label className="label cursor-pointer gap-x-1">
      <input
        type="radio"
        {...props}
        className={clsx('radio', props.className)}
      />
      <span className="text-sm text-base-content">{label}</span>
    </label>
  </div>
)
